<template>
  <b-row v-if="$route.name === 'EXABOrganizationLeadCreate'">
    <b-col cols="12">
      <b-row>
        <b-col>
          <router-link :to="{ name: 'EXABOrganizationLeadList' }" class="btn btn-default float-right">{{$t('buttons.backToList')}}</router-link>
        </b-col>
      </b-row>
    </b-col>
    <b-col>
      <div class="card">
        <template v-if="isLoading">
          <Loader></Loader>
        </template>
        <div class="card-body" v-else>
          <Form
            :handle-submit="onSendForm"
            :handle-update-field="updateField"
            :idStatus="idStatus"
            :idUserData="idUserData"
            :values="item"
            :errors="violations" />
        </div>
      </div>
    </b-col>
  </b-row>
  <b-row v-else>
    <b-col>
      <Form
        :handle-submit="onSendForm"
        :handle-update-field="updateField"
        :idStatus="idStatus"
        :idUserData="idUserData"
        :values="item"
        :errors="violations" />
    </b-col>
  </b-row>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import Form from './Form'
import Loader from '@/components/Dashboard/Layout/Loader.vue'

export default {
  name: 'EXABOrganizationLeadCreate',
  components: { Loader, Form },
  props: {
    idStatus: {
      type: String,
      required: false,
      default: null
    },
    idUserData: {
      type: String,
      required: false,
      default: null
    }
  },
  data () {
    return {
      item: {
        title: '',
        description: '',
        idUserData: this.idUserData,
        idSalesRepresentative: null,
        idStatus: this.idStatus,
        idSalesOpportunity: null,
        monthlyCost: '0',
        yearlyCost: '0',
        tags: []
      }
    }
  },
  computed: {
    ...mapGetters({
      violations: 'exaborganizationlead/create/violations',
      isLoading: 'exaborganizationlead/create/isLoading',
      created: 'exaborganizationlead/create/created'
    })
  },
  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function (created) {
      if (!created) {
        return
      }
      if (this.$route.name === 'EXABOrganizationLeadCreate') {
        this.$router.push({ name: 'EXABOrganizationLeadList' })
      }
    }
  },
  methods: {
    ...mapActions({
      create: 'exaborganizationlead/create/create'
    }),
    onSendForm () {
      let item = Object.assign({}, this.item)
      item.tags = this.item.tags.map(object => {
        return { tag: object.value }
      })
      this.create(item)
    },
    updateField (field, value) {
      Object.assign(this.item, { [field]: value })
    }
  }
}
</script>
